// GraphContext.js
import React, { createContext, useContext, useState } from 'react';

const GraphContext = createContext();

const GraphProvider = ({ children }) => {
    // Existing state variables
    const [trackId, setTrackId] = useState(null);
    const [pathId, setPathId] = useState(null);
    const [trackName, setTrackName] = useState(null);
    const [nodes, setNodes] = useState([]);
    const [edges, setEdges] = useState([]);
    const [graphType, setGraphType] = useState('');

    // Shared states between Graph and GraphViewPort
    const [loading, setLoading] = React.useState(true);
    const [selectedNode, setSelectedNode] = useState(null);
    const [scale, setScale] = useState(1); // Default initial scale
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [boundaries, setBoundaries] = useState({ minX: 0, maxX: 0, minY: 0, maxY: 0 });
    const [defaultBoundaries, setDefaultBoundaries] = useState({ minX: 0, maxX: 0, minY: 0, maxY: 0 });
    const [graphSize, setGraphSize] = useState({ w: 0, h: 0 });
    const [allowMovement, setAllowMovement] = useState(true);

    function setGraph(newTrackId, newTrackName, newNodes, newEdges) {
        if (newTrackId !== null) setTrackId(newTrackId);
        if (newTrackName !== null) setTrackName(newTrackName);
        if (newNodes !== null) setNodes(newNodes);
        if (newEdges !== null) setEdges(newEdges);
    }

    function resetGraph() {
        setTrackId(null);
        setPathId(null);
        setTrackName(null);
        setNodes([]);
        setEdges([]);
        setGraphType('');
        setLoading(true);
        setSelectedNode(null);
        setScale(1);
        setPosition({ x: 0, y: 0 });
        setBoundaries({ minX: 0, maxX: 0, minY: 0, maxY: 0 });
        setDefaultBoundaries({ minX: 0, maxX: 0, minY: 0, maxY: 0 });
        setGraphSize({ w: 0, h: 0 });
        setAllowMovement(true);
    }

    const value = {
        // Existing values
        trackId,
        setTrackId,
        trackName,
        setTrackName,
        nodes,
        setNodes,
        edges,
        setEdges,
        setGraph,
        // Shared states
        loading,
        setLoading,
        selectedNode,
        setSelectedNode,
        scale,
        setScale,
        position,
        setPosition,
        boundaries,
        setBoundaries,
        defaultBoundaries,
        setDefaultBoundaries,
        graphSize,
        setGraphSize,
        allowMovement,
        setAllowMovement,
        graphType,
        setGraphType,
        pathId,
        setPathId,
        resetGraph,
    };

    return <GraphContext.Provider value={value}>{children}</GraphContext.Provider>;
};

const useGraph = () => {
    return useContext(GraphContext);
};

export { GraphProvider, useGraph };
